import { Link } from 'react-router-dom';

const Editor = () => {
  return (
    <section className="recipe-lab">
      <h1>Editor</h1>
      <p>
        Recipe editing and build images are managed in the{' '}
        <Link to="/recipes">Recipe Book</Link>. Open My Recipes or Community to update your published recipes.
      </p>
    </section>
  );
};

export default Editor;